/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { RequestConfig, ResponseErrorConfig } from '../.kubb/client'
import type {
  GetOrderByIdOptions,
  GetOrderByIdStatus200,
  GetOrderByIdStatus400,
  GetOrderByIdStatus401,
  GetOrderByIdStatus404,
  GetOrderByIdStatus500,
} from '../types/GetOrderById'
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from '@tanstack/react-query'
import { getOrderById } from '../clients/getOrderById'
import { queryOptions, useQuery } from '@tanstack/react-query'

export const getOrderByIdQueryKey = ({ path }: Omit<GetOrderByIdOptions, 'headers'>) =>
  [{ url: '/v1/orders/:order_id', params: path }] as const

type GetOrderByIdQueryKey = ReturnType<typeof getOrderByIdQueryKey>

export function getOrderByIdQueryOptions(
  { path }: GetOrderByIdOptions,
  config: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>> = {},
) {
  const queryKey = getOrderByIdQueryKey({ path })
  return queryOptions<
    GetOrderByIdStatus200,
    ResponseErrorConfig<
      GetOrderByIdStatus400 | GetOrderByIdStatus401 | GetOrderByIdStatus404 | GetOrderByIdStatus500
    >,
    GetOrderByIdStatus200,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      return getOrderById({
        ...config,
        path,
        signal: config.signal ?? signal,
        throwOnError: true,
      }).unwrap()
    },
  })
}

/**
 * @description Get details of a specific order. Traders can only view their own orders. Admins can view any order. Integrators can view orders for users within their tenant.
 * @summary Get order by ID
 * {@link /v1/orders/:order_id}
 */
export function useGetOrderById<
  TData = GetOrderByIdStatus200,
  TQueryData = GetOrderByIdStatus200,
  TQueryKey extends QueryKey = GetOrderByIdQueryKey,
>(
  { path }: { path: GetOrderByIdOptions['path'] | (() => GetOrderByIdOptions['path']) },
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetOrderByIdStatus200,
        ResponseErrorConfig<
          | GetOrderByIdStatus400
          | GetOrderByIdStatus401
          | GetOrderByIdStatus404
          | GetOrderByIdStatus500
        >,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient }
    client?: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>>
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...resolvedOptions } = queryConfig
  const resolvedParams = { path: typeof path === 'function' ? path() : path }
  const queryKey = resolvedOptions?.queryKey ?? getOrderByIdQueryKey(resolvedParams)

  const queryResult = useQuery(
    {
      ...getOrderByIdQueryOptions(resolvedParams, config),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<
      GetOrderByIdStatus400 | GetOrderByIdStatus401 | GetOrderByIdStatus404 | GetOrderByIdStatus500
    >
  > & { queryKey: TQueryKey }

  queryResult.queryKey = queryKey as TQueryKey

  return queryResult
}
